import { render, staticRenderFns } from "./CartaoOSFilhas.vue?vue&type=template&id=435ac52c&scoped=true"
import script from "./CartaoOSFilhas.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoOSFilhas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoOSFilhas.vue?vue&type=style&index=0&id=435ac52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435ac52c",
  null
  
)

export default component.exports